import Image from "next/image";
import Link from "next/link";
import StarIcon from "@/components/icons/StarIcon";

export default function WallSection() {
  return (
    <section id="wall-section">
      <div className="flex justify-center w-full p-10 pt-16 lg:pt-[120px] px-[18px] lg:px-18">
        <div className="flex flex-col items-center justify-center w-full max-w-[1200px] gap-14">
          <div className="flex flex-col lg:flex-row justify-between gap-5 items-center lg:items-start w-full">
            <h1 className="max-w-[450px] text-center lg:text-start text-wrap !font-semibold text-[#0D2A4C] !text-[32px] md:!text-[56px] md:leading-[58px] leading-[32px] tracking-tighter">
              How Small Teams are Winning Big
            </h1>
            <div className="flex flex-col items-center lg:items-start gap-5 lg:gap-4">
              <p className="text-[#0D2A4C99] !font-medium text-sm lg:text-[16px] max-w-[340px] tracking-tight text-wrap">
                Founders and sales teams are turning ListKit leads into closed
                deals faster than ever.
              </p>
              <Link
                href="/wall-of-love"
                className="bg-[#2A8DFF] w-fit text-center hover:bg-[#2A8DFF]/90 active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] rounded-[100px] py-[11px] px-[18px] md:py-[15px] md:px-[22px] cursor-pointer"
              >
                <p className="text-white text-sm md:text-[16px] font-semibold tracking-tight">
                  See All Success Stories
                </p>
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-5 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              <div className="px-[18px] py-5 flex flex-col justify-between gap-5 bg-[#F8F9FA] w-full border border-[#0D2A4C08] rounded-[12px]">
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1">
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                  </div>
                  <p className="font-medium text-sm lg:text-[16px] leading-[22px] lg:leading-6 tracking-tighter text-[#0D2A4C99]">
                    It was much easier to use than Apollo or any other lead
                    scraper I&apos;ve used. They&apos;ve made the UI so
                    incredibly simple that it takes little to no time to get
                    started. They have some predefined filters which you can use
                    as the foundation of your lead search (e-commerce decision
                    makers, agency owners, coaching businesses or SAAS. You can
                    also limit the number of people per company you scrape so
                    that you don&apos;t waste credits. Getting a free onboarding
                    call was also massively helpful, as Francois ran me through
                    everything I needed to target my exact niche. And it was
                    incredibly reassuring that all the leads were
                    triple-verified, so I don&apos;t have to use other tools to
                    make sure they&apos;re verified again. Overall, they&apos;ve
                    really thought about what every user would want to have when
                    using a lead scraper, it&apos;s a job well done.
                  </p>
                </div>
                <div className="flex gap-2.5 items-center">
                  <div className="size-[42px] lg:size-[50px] rounded-full relative">
                    <Image
                      fill
                      sizes="50px"
                      src="/images/review-image-3.webp"
                      alt=""
                      className="object-cover rounded-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xl lg:text-2xl font-semibold leading-5 lg:leading-6 text-[#0D2A4C]">
                      Harry H.
                    </p>
                    <p className="text-sm lg:text-[16px] leading-5 lg:leading-[22px] text-[#0D2A4C99]">
                      Small-Business(50 or fewer emp.)
                    </p>
                  </div>
                </div>
              </div>

              <div className="px-[18px] py-5 flex flex-col justify-between gap-5 bg-[#F8F9FA] w-full border border-[#0D2A4C08] rounded-[12px]">
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1">
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                  </div>
                  <p className="font-medium text-sm lg:text-[16px] leading-[22px] lg:leading-6 tracking-tighter text-[#0D2A4C99]">
                    I use listkit for my cold email lead gen service and it is
                    by far the easiest software to find a scrape qualifed leads
                    from. Not to mention the customer service is extremely
                    helpful, I just got off a zoom call with a customer
                    representative who helped me build an I’m using listkit for
                    Lead Generation and have found it to be a superb tool. I was
                    given a free 30 minute one to one to go over how to pinpoint
                    the right people at the right companies to target. New
                    features are regularly coming out and excellent customer
                    support. inital sample list of my ICP where we filtered down
                    exactly who I was targeting - 11/10 stars. Listkit is the
                    best.
                  </p>
                </div>
                <div className="flex gap-2.5 items-center">
                  <div className="size-[42px] lg:size-[50px] rounded-full relative">
                    <Image
                      fill
                      sizes="50px"
                      src="/images/review-image-2.jpg"
                      alt=""
                      className="object-cover rounded-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xl lg:text-2xl font-semibold leading-5 lg:leading-6 text-[#0D2A4C]">
                      Ben M.
                    </p>
                    <p className="text-sm lg:text-[16px] leading-5 lg:leading-[22px] text-[#0D2A4C99]">
                      Small-Business(50 or fewer emp.)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              <div className="px-[18px] py-5 flex flex-col justify-between gap-5 bg-[#F8F9FA] w-full border border-[#0D2A4C08] rounded-[12px]">
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1">
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                  </div>
                  <p className="font-medium text-sm lg:text-[16px] leading-[22px] lg:leading-6 tracking-tighter text-[#0D2A4C99]">
                    It is super simple and straightforward to get started. Their
                    customer support is also top-notch. It also connects
                    automatically with SmartLead so I can just send my lists to
                    my email sending SW without having to deal with any CSV.
                    Love that!
                  </p>
                </div>
                <div className="flex gap-2.5 items-center">
                  <div className="size-[42px] lg:size-[50px] rounded-full relative">
                    <Image
                      fill
                      sizes="50px"
                      src="/images/review-image-1.jpg"
                      alt=""
                      className="object-cover rounded-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xl lg:text-2xl font-semibold leading-5 lg:leading-6 text-[#0D2A4C]">
                      Ben M.
                    </p>
                    <p className="text-sm lg:text-[16px] leading-5 lg:leading-[22px] text-[#0D2A4C99]">
                      Small-Business(50 or fewer emp.)
                    </p>
                  </div>
                </div>
              </div>
              <div className="px-[18px] py-5 flex flex-col justify-between gap-5 bg-[#F8F9FA] w-full border border-[#0D2A4C08] rounded-[12px]">
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1">
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                  </div>
                  <p className="font-medium text-sm lg:text-[16px] leading-[22px] lg:leading-6 tracking-tighter text-[#0D2A4C99]">
                    Great support, great onboarding, great tools, great lists do
                    you need more? The only thing I can think of that I
                    don&apos;t like is that phone credits are a bit pricy
                  </p>
                </div>
                <div className="flex gap-2.5 items-center">
                  <div className="size-[42px] lg:size-[50px] rounded-full relative">
                    <Image
                      fill
                      sizes="50px"
                      src="/images/review-image-4.png"
                      alt=""
                      className="object-cover rounded-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xl lg:text-2xl font-semibold leading-5 lg:leading-6 text-[#0D2A4C]">
                      Martin Myren
                    </p>
                  </div>
                </div>
              </div>
              <div className="px-[18px] py-5 flex flex-col justify-between gap-5 bg-[#F8F9FA] w-full border border-[#0D2A4C08] rounded-[12px]">
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1">
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                    <StarIcon className="text-[#FCCF1D] size-4" />
                  </div>
                  <p className="font-medium text-sm lg:text-[16px] leading-[22px] lg:leading-6 tracking-tighter text-[#0D2A4C99]">
                    The lead list is verified, and it has a great open rate from
                    my experience. I need to try it more, but so far, the
                    support is great too!
                  </p>
                </div>
                <div className="flex gap-2.5 items-center">
                  <div className="size-[42px] lg:size-[50px] rounded-full relative">
                    <Image
                      fill
                      sizes="50px"
                      src="/images/review-image-5.webp"
                      alt=""
                      className="object-cover rounded-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xl lg:text-2xl font-semibold leading-5 lg:leading-6 text-[#0D2A4C]">
                      Andreas B.
                    </p>
                    <p className="text-sm lg:text-[16px] leading-5 lg:leading-[22px] text-[#0D2A4C99]">
                      Small-Business(50 or fewer emp.)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
